module.exports = __webpack_public_path__ + "static/media/bt.87b0c87f.svg";